import React from 'react';
import { Cookie, Settings, X } from 'lucide-react';
import { useLanguage } from '@/contexts/language';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';

export const CookieConsentBanner = () => {
  const { t } = useLanguage();
  const { shouldShowBanner, acceptAll, rejectAll } = useCookieConsent();

  if (!shouldShowBanner()) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <Card className="max-w-3xl mx-auto shadow-lg border-2">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <Cookie className="h-6 w-6 text-orange-500 flex-shrink-0 mt-1" />

            <div className="flex-1">
              <h3 className="font-semibold text-lg mb-2">
                {t('legal.cookies.title')}
              </h3>

              <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                {t('legal.cookies.description')}
                {' '}
                <Link to="/cookies" className="text-primary hover:underline">
                  {t('legal.cookies.learnMore')}
                </Link>
              </p>

              <div className="flex flex-wrap gap-3">
                <Button onClick={acceptAll}>
                  {t('legal.cookies.acceptAll')}
                </Button>

                <Button variant="outline" onClick={rejectAll}>
                  {t('legal.cookies.rejectOptional')}
                </Button>

                <Button variant="ghost" asChild>
                  <Link to="/cookies">
                    {t('legal.cookies.customize')}
                  </Link>
                </Button>
              </div>
            </div>

            <Button
              variant="ghost"
              size="sm"
              onClick={rejectAll}
              className="flex-shrink-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};